<template>
  <div class="all-wrapper with-side-panel solid-bg-all">
     <div class="layout-w">
       <app-sidebar></app-sidebar>
       <div class="content-w">
         <app-navbar></app-navbar>
         <div class="content-i">
           <div class="content-box" v-if="!this.$root.isAuthenticated">
             <div class="row pt-4">
               <div class="col-sm-12">
                 <div class="alert alert-danger" role="alert" v-if="detectMob()">
                   Mobile version is not supported. Please use desktop browsers.
                 </div>
                 <div class="col-sm-10">
                  <div class="element-box" role="alert">
                  <h3>Welcome to ZERO ONE by Dreamstart!</h3>
                  <p>We are an IT infrastrucutre comapny providing online game services for Counter-Strike players. Click the (Connect) button now to play!</p>
                   </div>
                 </div>
                 <div class="element-wrapper">
                   <h6 class="element-header">
                     Home
                   </h6>
                 <div class="col-sm-6">
                  <div class="alert alert-primary" role="alert">
                    Payment and subscription information will be sent through email.<br>Subscription is accepted from ID, SG, MY, TH.
                   </div>
                 </div>
                   <div class="element-box">
                     <div class="table-responsive">
                       <table class="table table-lightborder">
                         <thead>
                           <tr>
                             <th>#</th>
                             <th>Name</th>
                             <th>Full Address</th>
                             <th>Type</th>
                             <th>Map</th>
                             <th>Players</th>
                             <th>Actions</th>
                           </tr>
                         </thead>
                         <tbody id="serverListTbl">
                           <tr v-for="(server, index) in servers">
                             <td>{{ index }}</td>
                             <td>{{ server.country + ' ' + server.name }}</td>
                             <td>{{ server.full_address }}</td>
                             <td>{{ server.type }}</td>
                             <td>{{ server.map.replace('_zero1', '') }}</td>
                             <td>{{ server.players }}</td>
                             <td><a class="btn btn-primary" v-bind:href="server.steam_url" role="button">Connect</a></td>
                           </tr>
                         </tbody>
                       </table>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
             <div class="row pt-4">
               <div class="col-sm-12">
                 <div class="element-wrapper">
                   <h6 class="element-header">
                     Recent Matches
                   </h6>
                   <div class="element-box">
                     <div class="table-responsive">
                       <table class="table table-lightborder">
                         <thead>
                           <tr>
                             <th>#</th>
                             <th>ID</th>
                             <th>Full Address</th>
                             <th>Map</th>
                             <th>Score</th>
                           </tr>
                         </thead>
                         <tbody id="serverListTbl">
                           <tr v-for="(match, index) in matches">
                             <td>{{ index }}</td>
                             <td>{{ match.id }}</td>
                             <td>{{ match.full_address }}</td>
                             <td>{{ match.map }}</td>
                             <td>[{{ match.score.terrorist }} : {{ match.score.ct }}]</td>
                           </tr>
                         </tbody>
                       </table>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
             <app-darkcolor></app-darkcolor>
           </div>
           <div class="content-box" v-else>
             <div class="row pt-4">
               <div class="col-sm-12">
                 <div class="element-wrapper">
                   <h6 class="element-header">
                     Home
                   </h6>
                   <div class="element-content">
                     <div class="row">
                       <div class="col-sm-4 col-xxxl-3">
                         <a class="element-box el-tablo" href="#">
                           <div class="label">
                             Country
                           </div>
                           <div class="value">
                             {{ this.$root.userProfile.country }}
                           </div>
                         </a>
                       </div>
                       <div class="col-sm-4 col-xxxl-3">
                         <a class="element-box el-tablo" href="#">
                           <div class="label">
                             Rank
                           </div>
                           <div class="value">
                             {{ this.$root.userProfile.rank.name }}
                           </div>
                         </a>
                       </div>
                       <div class="col-sm-4 col-xxxl-3" v-if="this.$root.userProfile.rank.name != 'player'">
                         <a class="element-box el-tablo" href="#">
                           <div class="label">
                             Expires In
                           </div>
                           <div class="value" style="font-size: 1.6rem">
                             {{ getReadableDays(this.$root.userProfile.rank.expiresAt) }}
                           </div>
                         </a>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
             <div class="row pt-4">
               <div class="col-sm-12">
                 <div class="element-wrapper">
                   <h6 class="element-header">
                     Statistics
                   </h6>
                   <div class="element-box">
                     <div class="table-responsive">
                       <table class="table table-lightborder">
                         <thead>
                           <tr>
                             <th>#</th>
                             <th>Game Mode</th>
                             <th>Kills</th>
                             <th>Deaths</th>
                             <th>Assists</th>
                             <th>Wins</th>
                             <th>Losses</th>
                             <th>Rounds</th>
                             <th>Rating</th>
                           </tr>
                         </thead>
                         <tbody id="serverListTbl">
                           <tr>
                             <td>0</td>
                             <td>Arena 1v1</td>
                             <td>{{ this.$root.userProfile.stats['multi1v1'].kills }}</td>
                             <td>{{ this.$root.userProfile.stats['multi1v1'].deaths }}</td>
                             <td>{{ this.$root.userProfile.stats['multi1v1'].assists }}</td>
                             <td>{{ this.multi1v1_profile.wins }}</td>
                             <td>{{ this.multi1v1_profile.losses }}</td>
                             <td>{{ this.multi1v1_profile.wins + this.multi1v1_profile.losses }}</td>
                             <td><b>{{ this.multi1v1_profile.rating }}</b></td>
                           </tr>
                           <tr>
                             <td>1</td>
                             <td>Retakes</td>
                             <td>{{ this.$root.userProfile.stats['retakes'].kills }}</td>
                             <td>{{ this.$root.userProfile.stats['retakes'].deaths }}</td>
                             <td>{{ this.$root.userProfile.stats['retakes'].assists }}</td>
                             <td>{{ this.$root.userProfile.stats['retakes'].wins }}</td>
                             <td>{{ this.$root.userProfile.stats['retakes'].losses }}</td>
                             <td>{{ this.$root.userProfile.stats['retakes'].rounds }}</td>
                             <td><b>{{ this.$root.userProfile.stats['retakes'].rating }}</b></td>
                           </tr>
                           <tr>
                             <td>2</td>
                             <td>PUG</td>
                             <td>{{ this.$root.userProfile.stats['pug'].kills }}</td>
                             <td>{{ this.$root.userProfile.stats['pug'].deaths }}</td>
                             <td>{{ this.$root.userProfile.stats['pug'].assists }}</td>
                             <td>{{ this.$root.userProfile.stats['pug'].wins }}</td>
                             <td>{{ this.$root.userProfile.stats['pug'].losses }}</td>
                             <td>{{ this.$root.userProfile.stats['pug'].rounds }}</td>
                             <td><b>{{ this.$root.userProfile.stats['pug'].rating }}</b></td>
                           </tr>
                         </tbody>
                       </table>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
             <div class="row pt-4">
               <div class="col-sm-12">
                 <div class="element-wrapper">
                   <h6 class="element-header">
                     Community Servers
                   </h6>
                   <div class="element-box">
                     <div class="table-responsive">
                       <table class="table table-lightborder">
                         <thead>
                           <tr>
                             <th>#</th>
                             <th>Name</th>
                             <th>Full Address</th>
                             <th>Type</th>
                             <th>Map</th>
                             <th>Players</th>
                             <th>Actions</th>
                           </tr>
                         </thead>
                         <tbody id="serverListTbl">
                           <tr v-for="(server, index) in servers">
                             <td>{{ index }}</td>
                             <td>{{ server.country + ' ' + server.name }}</td>
                             <td>{{ server.full_address }}</td>
                             <td>{{ server.type }}</td>
                             <td>{{ server.map.replace('_zero1', '') }}</td>
                             <td>{{ server.players }}</td>
                             <td><a class="btn btn-primary" v-bind:href="server.steam_url" role="button">Connect</a></td>
                           </tr>
                         </tbody>
                       </table>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
             <app-darkcolor></app-darkcolor>
             <app-invitation v-if="this.$root.isAuthenticated"></app-invitation>
           </div>
           <app-rightsidebar></app-rightsidebar>
         </div>
       </div>
     </div>
  </div>
</template>

<script>
import Navbar from './partials/Navbar.vue';
import Sidebar from './partials/Sidebar.vue';
import RightSidebar from './partials/RightSidebar';
import Invitation from './partials/Invitation';
import Alert from './partials/Alert';
import Moment from 'moment';

export default {
  name: 'Home',
  metaInfo: {
    title: 'home',
    titleTemplate: 'zero1 by Dreamstart | %s',
    meta: [
      { property: 'og:title', content: 'zero1 by Dreamstart | home' },
      { property: 'og:site_name', content: 'zero1' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://zero1.gg/'},
      { property: 'og:description', content: 'Providing public & private CS:GO servers' },
      { itemprop: 'name', content: 'zero1 by Dreamstart | home' },
      { itemprop: 'description', content: 'Providing public & private CS:GO servers'},
    ]
  },
  data() {
    return {
      welcomeText: 'Welcome to zero1!',
      servers: [],
      matches: [],
      errors: ["test"],
      rank: 'F',
      multi1v1_profile: {}
    }
  },
  computed: {
    //
  },
  methods: {
    getServers() {
      this.axios.get(`${this.API_URL}/api/v1/servers`).then((res) => {
        res.data.find((s, v) => {
          s.steam_url = `steam://connect/${s.full_address}`;
          this.servers.push(s);
        });
      });
    },
    getMulti1v1Player() {
      this.axios.get(`${this.API_URL}/apollo/stats/multi1v1/${this.$root.userProfile.id}`).then((res) => {
        this.multi1v1_profile = res.data;
      });
    },
    getMatches() {
      this.axios.get(`${this.API_URL}/apollo/matches`).then((res) => {
        this.matches = res.data;
      });
    },
    pay(package_name, method) {
      this.axios.post(`${this.API_URL}/invoices/create`, { type: package_name, method: method }).then((res) => {
        if (method === 'xendit') {
          window.location.href = res.data.invoice_url;
        } else if (method === 'coowry') {
          this.errors.push('Please check your mobile phone for SMS!');
        }
      }).catch((err) => {
        this.errors = [];
        this.errors.push(err.response.data.message);
      });
    },
    connectDiscord() {
      this.axios.get(`https://discord.gg/mtwt4Ay`).then((res) => {
        window.location.href = res.data.url;
      });
    },
    getReadableDays(date) {
      return Moment(date).fromNow();
    },
    detectMob() {
     if( navigator.userAgent.match(/Android/i)
     || navigator.userAgent.match(/webOS/i)
     || navigator.userAgent.match(/iPhone/i)
     || navigator.userAgent.match(/iPad/i)
     || navigator.userAgent.match(/iPod/i)
     || navigator.userAgent.match(/BlackBerry/i)
     || navigator.userAgent.match(/Windows Phone/i)
     ){
        return true;
      }
     else {
        return false;
      }
    }
  },
  watch: {
    '$root.isAuthenticated': function(isAuthenticated) {
      if (isAuthenticated) {
        this.getMulti1v1Player();
      }
    }
  },
  created() {
    if (this.$route.query && this.$route.query.hasOwnProperty('authToken')) {
      this.$root.authToken = this.$route.query.authToken;
    }

    window.$('body').addClass('before-body menu-position-side menu-side-left full-screen with-content-panel');
    this.getServers();
    if (!this.$root.isAuthenticated) {
      this.getMatches();
    }

    Number.prototype.between = function(a, b) {
      var min = Math.min.apply(Math, [a, b]),
        max = Math.max.apply(Math, [a, b]);
      return this > min && this < max;
    }

    if (this.$root.krakenProfile.level.between(0, 500)) {
      this.rank = 'F'
    } else if (this.$root.krakenProfile.level.between(500, 1000)) {
      this.rank = 'F+'
    } else if (this.$root.krakenProfile.level.between(1000, 1500)) {
      this.rank = 'E'
    } else if (this.$root.krakenProfile.level.between(1500, 2000)) {
      this.rank = 'E+'
    } else if (this.$root.krakenProfile.level.between(2000, 2500)) {
      this.rank = 'D'
    } else if (this.$root.krakenProfile.level.between(2500, 3000)) {
      this.rank = 'D+'
    } else if (this.$root.krakenProfile.level.between(3000, 3500)) {
      this.rank = 'C'
    } else if (this.$root.krakenProfile.level.between(4000, 4500)) {
      this.rank = 'C+'
    } else if (this.$root.krakenProfile.level.between(4000, 4500)) {
      this.rank = 'B'
    } else if (this.$root.krakenProfile.level.between(4500, 5000)) {
      this.rank = 'B+'
    } else if (this.$root.krakenProfile.level.between(5000, 5500)) {
      this.rank = 'A'
    } else if (this.$root.krakenProfile.level.between(5500, 6000)) {
      this.rank = 'A+'
    }

    if (this.$root.isAuthenticated) {
      this.getMulti1v1Player();
    }

  },
  mounted() {
    //
  },
  components: {
    'app-navbar': Navbar,
    'app-sidebar': Sidebar,
    'app-alert': Alert,
    'app-rightsidebar': RightSidebar,
    'app-invitation': Invitation
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
